import {
  RECORDING_VIDEO_QUALITY,
  NOTIFICATIONS_TYPE,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_CATEGORIES_TITLES
} from '../constants/notificationsConstants'
angular.module('surfsightApp.controllers').controller('notificationItemCtrl', [
  '$scope',
  '$rootScope',
  '$mdDialog',
  '$http',
  'notificationsFactory',
  function ($scope, $rootScope, $mdDialog, $http, notificationsFactory) {
    $scope.notifications = []
    $scope.loading = false
    $scope.limit = notificationsFactory.pageSize
    $scope.hasMoreNotificationsToLoad = true
    $scope.initialDataProcessing = false
    // Load initial notifications and process them according to UI display requirements
    const initialLoadEvent = $rootScope.$on(
      'fetchNotificationsEvent',
      async () => {
        try {
          // If already processing, return.
          if ($scope.initialDataProcessing) return
          $scope.loading = true
          $scope.initialDataProcessing = true
          $scope.notifications.length = 0
          $scope.limit = notificationsFactory.pageSize
          notificationsFactory.list.splice(0, notificationsFactory.list.length)
          notificationsFactory.clear()
          await notificationsFactory
            .loadMoreNotifications()
            .then(response => {
              if (response && response.length > 0) {
                $scope.notifications = [...response]
                $scope.notifications.map(notification => {
                  notification.title = NOTIFICATION_CATEGORIES_TITLES[
                    NOTIFICATIONS_TYPE[notification.type].notificationCategory
                  ](
                    notification.metadata,
                    NOTIFICATIONS_TYPE[notification.type].notificationTitle
                  )
                  notification.category =
                    NOTIFICATIONS_TYPE[notification.type].notificationCategory
                  return notification
                })
                $scope.limit += notificationsFactory.pageSize
                if (response.length < notificationsFactory.pageSize) {
                  $scope.hasMoreNotificationsToLoad = false
                } else {
                  $scope.hasMoreNotificationsToLoad = true
                }
              } else {
                $scope.hasMoreNotificationsToLoad = false
              }
            })
            .finally(() => {
              $scope.loading = false
              $scope.initialDataProcessing = false
              $scope.$apply()
            })
        } catch (error) {
          console.log('Error while fetching notifications = ', error)
          $scope.loading = false
          $scope.$apply()
        }
      }
    )
    $scope.showDownloadedRecordingVideoModal = async (notification, event) => {
      // Get presigned link for the recording and show the modal
      const { metadata, uuid } = notification
      const { imei } = metadata
      const requestJson = {
        method: 'GET',
        url: `${DEVICEMANAGER_BASEURL}/device/${imei}/${uuid}/presigned-link`
      }
      const { data: recordingData } = await $http(requestJson)
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              notification: notification,
              recordingUrl: recordingData.data
            }
          },
          controller: 'edgeDownloadRecordingVideoModalController',
          templateUrl:
            './templates/edge.recording.videos.modal.view.html?t=' +
            window.webpackHash,
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(() => {})
        .catch(error => {
          console.error('Error while fetching presigned link = ', error)
        })
    }

    $scope.downloadDeviceReport = async (notification, event) => {
      const { uuid, type } = notification
      const requestJson = {
        method: 'GET',
        url: `${DEVICEMANAGER_BASEURL}/device/${type}/${uuid}/reports-presigned-link`
      }
      const { data: reportData } = await $http(requestJson)

      const url = reportData.data ? reportData.data.url : notification.url
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = (notification.title || 'data-usage-report') + '.csv'
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
    }
    $scope.loadMore = async (last, inview) => {
      try {
        if (last && inview && $scope.hasMoreNotificationsToLoad) {
          $scope.loading = true
          const response = await notificationsFactory.loadMoreNotifications()
          if (response.length > 0) {
            $scope.notifications = [...$scope.notifications, ...response]
            $scope.limit += notificationsFactory.pageSize
            if (response.length < notificationsFactory.pageSize) {
              $scope.hasMoreNotificationsToLoad = false
            } else {
              $scope.hasMoreNotificationsToLoad = true
            }
          } else if (
            response.length === 0 ||
            response.length < notificationsFactory.pageSize
          ) {
            $scope.hasMoreNotificationsToLoad = false
          }
          $scope.loading = false
          $scope.$apply()
        }
      } catch (error) {
        console.error('Error loading notifications:', error)
        $scope.loading = false
        $scope.$apply()
      }
    }
    $scope.tryAgainDownloadingRecording = function (notification) {
      //  send download request again.
      try {
        const { uuid, metadata } = notification
        const { imei, duration, quality, startTime, streamId } = metadata
        const requestJson = {
          method: 'POST',
          url: `${DEVICEMANAGER_BASEURL}/device/${imei}/recording-download`,
          data: {
            duration,
            streamId,
            startTime: new Date(startTime * 1000).toISOString(),
            quality:
              quality === RECORDING_VIDEO_QUALITY.LowQuality
                ? 'standard'
                : 'high',
            isRetryRequest: true
          },
          headers: { 'x-request-id': uuid }
        }
        $http(requestJson)
        // Update polling frequest for the notification.
        $rootScope.$emit('RecordingRequestedWithTryAgainEvent')
      } catch (error) {
        console.error('Error while downloading file = ', error)
      }
    }
    $scope.cancel = function () {
      $mdDialog.cancel()
    }

    // Clean up the listener when the scope is destroyed
    $scope.$on('$destroy', function () {
      initialLoadEvent() // Remove the listener
    })
  }
])
